// extracted by mini-css-extract-plugin
module.exports = {"container":"_2jYLxw83gSDYH8WECxXRYn"};